import { z } from "zod";

import { fireDrillSchema } from "../../../schemas";

const annualBehavioralHealthFireDrillSchema = z.object({
  ...fireDrillSchema.shape,
  signalType: z.string(),
  supportedQuantity: z.coerce.number().min(1),
  meetingPlace: z.string().min(1, "Required"),
  evacDurationMinutes: z.coerce.number().min(1),
  evacDurationSeconds: z.coerce
    .number()
    .min(0)
    .max(59, "Seconds must be less that 60"),
  exitUsed: z.string().min(1, "Required"),
  drillStatus: z.string(),
  drillStatusOther: z.string().optional(),
  comments: z.string().optional(),
});

export const fireDrillCreateSchema =
  annualBehavioralHealthFireDrillSchema.superRefine(
    ({ auditDate }, refinementContext) => {
      const date = new Date();
      if (date > new Date(date.getFullYear(), date.getMonth(), 5)) {
        if (auditDate < new Date(date.getFullYear(), date.getMonth(), 1)) {
          refinementContext.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Date not in submission window",
            path: ["auditDate"],
          });
        }
      } else {
        if (auditDate < new Date(date.getFullYear(), date.getMonth() - 1, 1)) {
          refinementContext.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Date not in submission window",
            path: ["auditDate"],
          });
        }
      }
    },
  );

export const fireDrillEditSchema = annualBehavioralHealthFireDrillSchema;
